// === GIX custom hook for PaginatedList (works in shadowDOM themes) ===
function moveSoldOutProducts(root) {
  if (!root) return;
  const grid =
    root.querySelector('[data-products-grid]') ||
    root.querySelector('.product-grid') ||
    root.querySelector('ul');
  if (!grid) return;

  const items = Array.from(grid.children);
  if (!items.length) return;

  const available = [];
  const soldOut = [];

  items.forEach((el) => {
    const badge = el.querySelector('.product-badges__badge, .product-badge, .badge');
    const text = badge ? badge.textContent.toLowerCase() : '';
    if (text.includes('изчерпан') || text.includes('sold out')) {
      soldOut.push(el);
    } else {
      available.push(el);
    }
  });

  if (soldOut.length && available.length) {
    soldOut.forEach((el) => grid.appendChild(el));
  }
}

window.customElements.whenDefined('results-list').then(() => {
  // ResultsList наследява PaginatedList → достъп до класа през import
  const ResultsList = customElements.get('results-list');
  const proto = Object.getPrototypeOf(ResultsList.prototype);
  const originalRenderPage = proto.renderPage || proto.updateResults || proto.render;

  if (!originalRenderPage) {
    console.warn('⚠️ GIX reorder-soldout: no renderPage found');
    return;
  }

  proto.renderPage = function (...args) {
    // извикваме оригиналното рендиране
    const result = originalRenderPage.apply(this, args);

    // след като продуктите са инжектирани
    setTimeout(() => moveSoldOutProducts(this), 300);

    return result;
  };
});
